import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import CollectionsIcon from '@mui/icons-material/Collections';
import ComputerIcon from '@mui/icons-material/Computer';
import HomeIcon from '@mui/icons-material/Home';
import ArticleIcon from '@mui/icons-material/Article';
import HttpIcon from '@mui/icons-material/Http';
import TableIcon from '@mui/icons-material/TableView';
import { useNavigate } from 'react-router-dom';
import { Divider, List } from '@mui/material';
import { store } from '../redux/store';


export default function ListItems(){
  
  const navigate = useNavigate();
  const [active,setActive] = React.useState<string>("desktop");
  return (
    <List>
      <React.Fragment>
        <ListItemButton onClick={()=>{navigate("/")}}>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="首页" />
        </ListItemButton>
        <Divider sx={{ my: 1 }} />
      </React.Fragment>

      {
      store.getState().account.mail === "rzhangshaoju.12@gmail.com" &&
      <React.Fragment>
        <ListSubheader component="div" inset>
          文档管理
        </ListSubheader>
        <ListItemButton>
          <ListItemIcon>
            <ArticleIcon />
          </ListItemIcon>
          <ListItemText primary="我的文档" />
        </ListItemButton>
        <ListItemButton onClick={()=>{navigate("/sheet/abc")}}>
          <ListItemIcon>
            <TableIcon />
          </ListItemIcon>
          <ListItemText primary="我的表格" />
        </ListItemButton>
        <ListItemButton>
          <ListItemIcon>
            <CollectionsIcon />
          </ListItemIcon>
          <ListItemText primary="素材资料" />
        </ListItemButton>
        <Divider sx={{my:1}}></Divider>
      </React.Fragment>
      }

      <React.Fragment>
        <ListSubheader component="div" inset>
          网络服务
        </ListSubheader>
        <ListItemButton onClick={()=>{setActive("desktop");navigate("/console/desktop")}}>
          <ListItemIcon>
            <ComputerIcon />
          </ListItemIcon>
          <ListItemText primary="远程桌面服务" style={active==="desktop"?{color:"grey"}:{color:"black"}}/>
        </ListItemButton>
        <ListItemButton onClick={()=>{setActive("website");navigate("/console/desktop/website")}}>
          <ListItemIcon>
            <HttpIcon />
          </ListItemIcon>
          <ListItemText primary="网站中继服务" style={active==="website"?{color:"grey"}:{color:"black"}}/>
        </ListItemButton>
      </React.Fragment>
    </List>
  )
}